import React from 'react';
import { Home, Search, BookOpen, User } from 'lucide-react';

/**
 * BottomNavigation component that displays navigation tabs
 * Enhanced to support custom navigation items and material theming
 */
const BottomNavigation = ({ 
  activeTab, 
  setActiveTab, 
  primaryColor, 
  secondaryColor,
  materialTheme,
  navItems
}) => {
  // Use provided navItems or fall back to defaults
  const tabs = navItems || [
    { id: 'home', icon: <Home className="w-5 h-5" />, label: 'Home' },
    { id: 'search', icon: <Search className="w-5 h-5" />, label: 'Search' },
    { id: 'library', icon: <BookOpen className="w-5 h-5" />, label: 'Library' },
    { id: 'profile', icon: <User className="w-5 h-5" />, label: 'Profile' }
  ];

  // Apply material design style if specified
  const materialStyle = materialTheme ? {
    backgroundColor: primaryColor,
    borderTop: 'none',
    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
  } : {
    backgroundColor: 'white',
    borderTop: '1px solid #e5e7eb',
    boxShadow: '0 -2px 10px rgba(0,0,0,0.05)'
  };

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 h-16 flex justify-around items-center"
      style={materialStyle}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        
        // Define colors based on active state and material theme
        const iconColor = materialTheme
          ? isActive 
            ? secondaryColor || '#ffffff' 
            : 'rgba(255,255,255,0.7)'
          : isActive 
            ? primaryColor 
            : '#6b7280';
            
        const textColor = materialTheme
          ? isActive 
            ? secondaryColor || '#ffffff' 
            : 'rgba(255,255,255,0.7)'
          : isActive 
            ? primaryColor 
            : '#6b7280';
            
        // Add indicator style for material design
        const indicatorStyle = materialTheme && isActive
          ? {
              position: 'absolute',
              bottom: '0',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '40%',
              height: '3px',
              backgroundColor: secondaryColor || '#ffffff',
              borderRadius: '3px 3px 0 0'
            }
          : {};
        
        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className="flex flex-col items-center justify-center w-full h-full relative"
          >
            <div className="flex items-center justify-center mb-1" style={{ color: iconColor }}>
              {/* Use the icon JSX element from the tab */}
              {typeof tab.icon === 'function' 
                ? <tab.icon size={20} style={{ color: iconColor }} />
                : React.cloneElement(tab.icon, { style: { color: iconColor } })
              }
            </div>
            <span 
              className={`text-xs ${isActive ? 'font-medium' : 'font-normal'}`}
              style={{ color: textColor }}
            >
              {tab.label}
            </span>
            
            {/* Material theme active indicator */}
            {materialTheme && isActive && (
              <div style={indicatorStyle}></div>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default BottomNavigation; 